const companyTheme = {
  dot: "bg-slate-400",
  accentText: "text-slate-200",
  subtleText: "text-slate-300",
  tabActive: "border-slate-400/40 bg-slate-500/10 text-slate-100",
  selectedRow: "border-l-2 border-slate-400 bg-slate-500/[0.08]",
  accentBadge: "border border-slate-400/30 bg-slate-500/10 text-slate-100",
  idBadge: "border border-slate-400/25 bg-slate-500/5 text-slate-100",
  detailBorder: "border-slate-500/30",
  detailGlow: "from-slate-500/20",
  checkbox:
    "border-slate-300/40 text-slate-200 hover:border-slate-200/60 hover:bg-slate-900/70 focus-visible:ring-slate-300/25",
  checkboxChecked:
    "border-slate-100/75 from-slate-300 to-slate-400 shadow-[0_0_0_1px_rgba(226,232,240,0.18),0_10px_22px_rgba(100,116,139,0.24)]",
};

export default companyTheme;
